import { useClientContractTermDetailHeader } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientContractTermDetailHeaderPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 詳細ヘッダー Container コンポーネント
 *
 * 企業契約期間 API から取得した利用企業名を breadcrumb 付きページヘッダーに表示する。
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 */
export const ClientContractTermDetailHeader: React.FC<Props> = ({ clientId, termId }) => {
  const {
    state: { data },
  } = useClientContractTermDetailHeader({ clientId, termId });

  const { clientName } = convertToPresentationProps({ data });

  return <ClientContractTermDetailHeaderPresentation clientName={clientName} />;
};
